import moment from "moment";

import { isValidDocumentID } from "../../../../../../utils/validation";
import { InsuredPersonalDataDto } from "./insured-personal-information-dto";

interface ValidateFormDataProps {
  person: InsuredPersonalDataDto;
  insureds: any;
  insuredIndex: number;
  taker: any;
}

export const validateFormData = ({
  person,
  insureds,
  insuredIndex,
  taker,
}: ValidateFormDataProps): any => {
  let noErrors = true;

  if (person.name.value.length === 0) {
    person.name.errorCode = "required";
    noErrors = false;
  }

  if (person.lastName1.value.length === 0) {
    person.lastName1.errorCode = "required";
    noErrors = false;
  }

  if (
    person.nationality &&
    person.nationality.code === "ESPA" &&
    person.lastName2.value.length === 0
  ) {
    person.lastName2.errorCode = "required";
    noErrors = false;
  }

  if (person.birthDate.value.length === 0) {
    person.birthDate.errorCode = "required";
    noErrors = false;
  } else {
    if (moment(person.birthDate.value, "DD/MM/YYYY").isAfter(moment())) {
      person.birthDate.errorCode = "invalid-date";
      noErrors = false;
    }
  }

  if (person.nationality.value.length === 0) {
    person.nationality.errorCode = "required";
    noErrors = false;
  }

  if (person.docType.value !== "MENOR" && person.docNumber.value.length === 0) {
    person.docNumber.errorCode = "required";
    noErrors = false;
  } else if (
    !isValidDocumentID(
      person.docNumber.value,
      person.docType.value === "MENOR" ? "NIF" : person.docType.value
    )
  ) {
    if (person.docType.value !== "MENOR" && person.docNumber.value.length > 0) {
      person.docNumber.errorCode = "invalid-document-dni";
      noErrors = false;
    }

    if (
      person.docType.value !== "MENOR" &&
      person.docType.value === "NIF" &&
      person.docNumber.value.length === 9
    ) {
      person.docNumber.errorCode = "invalid-document-dni";
      noErrors = false;
    } else {
      if (person.docType.value !== "MENOR") {
        person.docNumber.errorCode = "invalid-format";
        noErrors = false;
      }
    }
  } else if (insureds && insureds.length) {
    insureds.forEach((insured: any, index: number) => {
      if (insured.docNumber === person.docNumber.value && index !== insuredIndex) {
        person.docNumber.errorCode = "repeated-document-number";
        noErrors = false;
      }
    });
    if (!person.sameAsTaker && taker && person.docNumber.value === taker.docNumber) {
      person.docNumber.errorCode = "repeated-document-number-taker";
      noErrors = false;
    }
  }

  if (person.sex.value.length === 0) {
    person.sex.errorCode = "required";
    noErrors = false;
  }

  if (person.docType.value.length === 0) {
    person.docType.errorCode = "required";
    noErrors = false;
  }

  if (person.docType.value === "PAS" && person.passportDate.value.length === 0) {
    person.passportDate.errorCode = "required";
    noErrors = false;
  }

  if (person.profession.value === "OTRA") {
    if (person.profession.other.value.length === 0) {
      noErrors = false;
      person.profession.other.errorCode = "required";
    }
  }

  return {
    noErrors,
    newPerson: person,
  };
};
